// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { ArtifactTypeSchema } from '../inputTypeSchemas/ArtifactTypeSchema'

/////////////////////////////////////////
// ARTIFACT SCHEMA
/////////////////////////////////////////

export const ArtifactSchema = z.object({
  type: ArtifactTypeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  executionId: z.string().nullable(),
  traceId: z.string().nullable(),
  threadId: z.string().nullable(),
  runtimeId: z.string().nullable(),
  toolName: z.string().nullable(),
  toolCallId: z.string().nullable(),
  actionFileName: z.string().nullable(),
  actionContent: z.string().nullable(),
  actionContentSize: z.number().int().nullable(),
  resultFileName: z.string().nullable(),
  resultContent: z.string().nullable(),
  resultContentSize: z.number().int().nullable(),
  startedAt: z.coerce.date(),
  completedAt: z.coerce.date().nullable(),
  durationMs: z.number().int().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type Artifact = z.infer<typeof ArtifactSchema>

export default ArtifactSchema;
